import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SlidePanel extends Component {
  static wrapChild(child, className, style) {
    return (
      <div className={className} style={style}>
        {child}
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.renderChild = this.renderChild.bind(this);
  }

  getSlideClassName() {
    const { direction } = this.props;
    let className = 'bhp-left';
    if (direction.toLowerCase() === 'right') {
      className = 'bhp-right';
    }
    return className;
  }

  getSlideStyle() {
    const { width, show } = this.props;
    return show ? { width } : { width: 0 };
  }

  getPushStyle() {
    const { direction, width, show } = this.props;
    if (direction.toLowerCase() === 'right') {
      return show ? { marginRight: width } : { marginRight: 0 };
    }
    return show ? { marginLeft: width } : { marginLeft: 0 };
  }

  renderChild(child, index) {
    const className = this.getSlideClassName();
    let childComponent;

    switch (index) {
    case 0:
      childComponent = SlidePanel.wrapChild(child, `bhp-slide ${className}`, this.getSlideStyle());
      break;

    case 1:
      childComponent = SlidePanel.wrapChild(child, 'bhp-push', this.getPushStyle());
      break;

    default:
      childComponent = child;
      break;
    }
    return childComponent;
  }

  render() {
    const { children } = this.props;
    return (
      <div className="bhp-slide-panel">
        {React.Children.map(children, this.renderChild)}
      </div>
    );
  }
}

SlidePanel.propTypes = {
  direction: PropTypes.string, // Slide out from left or right
  width: PropTypes.number, // Width of the Slide Out Panel
  show: PropTypes.bool,
  children: PropTypes.array
};

SlidePanel.defaultProps = {
  direction: 'left',
  width: 350,
  show: true,
  children: []
};

export default SlidePanel;
